export const CONSUMO_COMPONENT_DESIGN = {
    page: {
        container: "flex flex-col h-full w-full gap-6 p-2 md:p-0 animate-in fade-in slide-in-from-bottom-4 duration-500",
        header: {
            container: "flex flex-col md:flex-row justify-between items-start md:items-center gap-4",
            title: "text-2xl font-bold text-gray-900 tracking-tight",
            subtitle: "text-sm text-gray-500 mt-1"
        }
    },
    cards: {
        container: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4",
        card: "bg-white p-4 rounded-xl shadow-sm border border-gray-100 cursor-pointer hover:shadow-md hover:border-violet-300 transition-all group",
        title: "text-sm font-semibold text-violet-600",
        value: "text-sm font-bold",
        label: "text-xs text-gray-600"
    },
    dialog: {
        content: "sm:max-w-[95vw] sm:min-w-[90vw] max-w-[95vw] max-h-[90vh] overflow-hidden flex flex-col p-0 rounded-xl",
        header: "p-6 pb-2 border-b border-gray-100",
        body: "flex-1 flex gap-4 overflow-hidden p-6 pt-4 bg-gray-50/50"
    }
};
